import { Link } from "wouter";
import { EyeOff } from "lucide-react";
import { useIsAuthenticated } from "@/lib/auth";
import { useSiteSettings } from "@/lib/cms";
import { isMaintenanceActive } from "@shared/maintenance";

/**
 * Figyelmeztető sáv a publikus oldal tetején, CSAK bejelentkezett adminnak,
 * amíg a „Hamarosan" mód aktív. Enélkül könnyű elfelejteni, hogy a látogatók
 * épp nem látják az oldalt — az admin ugyanis a valódi tartalmat kapja.
 */
export function MaintenanceAdminBar() {
  const isAdmin = useIsAuthenticated();
  const settings = useSiteSettings();
  if (!isAdmin || !isMaintenanceActive(settings.maintenance)) return null;
  return (
    <div className="bg-amber-500 text-white text-xs sm:text-sm">
      <div className="container py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
        <EyeOff size={15} className="shrink-0" />
        <span className="font-semibold uppercase tracking-widish">
          „Hamarosan" mód aktív
        </span>
        <span className="opacity-90">
          A látogatók nem látják a tartalmat — Ön adminként igen.
        </span>
        <Link
          href="/admin/site-settings"
          className="underline font-semibold whitespace-nowrap"
        >
          Beállítás
        </Link>
      </div>
    </div>
  );
}
